import { useCallback } from 'react'
import type { Session } from '@supabase/supabase-js'
import { getBookingTimeline } from '../../lib/admin-api'
import { TimelineList, useTimelineEvents } from '../shared/TimelineList'

// No module-level cache. A first-page fetch is ~one DB query and a few KB;
// caching introduces a stale-after-mutation bug (trigger price check → close →
// reopen shows old events) that's worse than the latency it saves.

export function BookingTimeline({ bookingId, session }: { bookingId: string; session: Session }) {
  const fetchPage = useCallback(
    (cursor: Parameters<typeof getBookingTimeline>[2]) => getBookingTimeline(session, bookingId, cursor),
    [session, bookingId],
  )
  const timeline = useTimelineEvents(fetchPage, [session, bookingId])

  return (
    <TimelineList
      timeline={timeline}
      skeletonRows={3}
      ariaLabel="Booking timeline"
      emptyState={
        <div className="text-sm text-stone-400 dark:text-stone-500">
          <p>Booking created. No activity yet.</p>
          <p className="mt-1">Price checks run twice daily (8am/8pm UTC).</p>
        </div>
      }
    />
  )
}
